import React, { useEffect, useState } from 'react';
import '../../../index.scss';
import DateTimeSePickersTyping from 'components/DatePicker/DateTimeSePickersTyping';

// material
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// ICON

import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
// other
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { GridColDef } from '@material-ui/data-grid';
import styled from 'styled-components';
import { Iobject } from 'main_type';
import { setLoadingRedux } from 'reducers/shareData/action';
import WarehouseModal from 'components/Modal/WareHouseModal';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import { isType3, isTypeIE, userTypeList } from 'main_consts';
import Header from 'components/Header';
import Radio from '../../../components/Radio';
// component
import Menu from '../../../components/Menu';
import {
  checkboxChange,
  formatDateTime,
  getColWidthByField,
  getDateDayPlus,
  getExpressName,
  getWarehouse,
  inputChange,
  radioChange,
  initWhrehhouse,
} from '../../../main_func';
import Input from '../../../components/Material/Input';
import { FormTitle, HVcGrid, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  blobDownload,
  getExcel,
  getSearch,
  snackBarRsp,
} from '../../../main_api';
import CheckBox from '../../../components/Material/Checkbox';

import Table from '../../../components/Material/Table/index';
import {
  ImanifDeclMwbQryResultSet,
  Imaster,
  IGetMawbNoList,
  ImanifDeclMwbQryStat1,
  ImanifDeclMwbQryStat2,
  IsearchResponse,
} from './type';

const DivStyle = styled.div`
  border: 3px outset #1c6ea4;
  margin-bottom: 1rem;
`;

/** 主提單查詢 */
const ManifDeclMwbQry = (): JSX.Element => {
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  const { enqueueSnackbar } = useSnackbar();
  // call login
  const masterDefaultValue: Imaster = {
    // 記帳代號
    chkCode1: (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',
    // 業者名稱
    expressCnName: '',
    // 快遞倉站
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : '',
    // 主號
    mawbNo1: '',
    mawbNo2: '',
    mawbNo3: '',
    mawbNo4: '',
    mawbNo5: '',
    // 分號
    hawbNo: '',
    // 日期
    startDate: getDateDayPlus(),
    endDate: getDateDayPlus(),
    startTime: '0000',
    endTime: '2359',
    // 是否加入時間查詢
    timeCheck: '0',
    endDateValid: true,
    endTimeValid: true,
    startDateValid: true,
    startTimeValid: true,
  };
  const apiName = 'manifDeclMwbQry';
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [colList, setColList] = useState<GridColDef[]>([]);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [rowData, setRowData] = useState<ImanifDeclMwbQryResultSet[]>([]);
  const [mawbQryStat1, setMawbQryStat1] = useState<ImanifDeclMwbQryStat1>(
    {} as ImanifDeclMwbQryStat1
  );
  const [mawbQryStat2, setMawbQryStat2] = useState<ImanifDeclMwbQryStat2>(
    {} as ImanifDeclMwbQryStat2
  );

  const [searchPara, setSearchPara] = useState<IGetMawbNoList>({
    mawbNoList: [],
  });

  useEffect(() => {
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
    if (
      userTypeList.type4.some((v) => v === userType) &&
      locationCode.trim().length === 0
    ) {
      setFormError(true);
    }
    if (isTypeIE(userType)) {
      setFormError(true);
    }
  }, [userType]);

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const type1Result: string[] = [];
    for (let i = 1; i <= 5; i += 1) {
      if ((master[`mawbNo${i}`] as string).length > 0) {
        type1Result.push(master[`mawbNo${i}`] as string);
      }
    }
    setSearchPara({ mawbNoList: [] });

    const result = await getExcel(apiName, {
      chkCode1: master.chkCode1,
      warehouse: master.warehouse,
      mawbNoList: type1Result,
      hawbNo: master.hawbNo,
      timeCheck: master.timeCheck,
      startDate:
        master.timeCheck === '1'
          ? formatDateTime(master.startDate, `${master.startTime}00`)
          : '',
      endDate:
        master.timeCheck === '1'
          ? formatDateTime(master.endDate, `${master.endTime}59`)
          : '',
    });
    const startDate = formatDateTime(
      master.startDate,
      master.startTime,
      'MMdd'
    );
    const EndDate = formatDateTime(master.endDate, master.endTime, 'MMdd');

    let mawbNoString: string;
    mawbNoString = '';
    for (let i = 1; i <= 5; i += 1) {
      if ((master[`mawbNo${i}`] as string).length > 0) {
        mawbNoString += master[`mawbNo${i}`];
        mawbNoString += '_';
      }
    }

    blobDownload(
      result,
      enqueueSnackbar,
      `${mawbNoString}艙報單主號差異表.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const type1Result: string[] = [];
    for (let i = 1; i <= 5; i += 1) {
      if ((master[`mawbNo${i}`] as string).length > 0) {
        type1Result.push(master[`mawbNo${i}`] as string);
      }
    }
    setSearchPara({ mawbNoList: [] });

    const result = await getSearch(apiName, {
      chkCode1: master.chkCode1,
      warehouse: master.warehouse,
      mawbNoList: type1Result,
      hawbNo: master.hawbNo,
      timeCheck: master.timeCheck,
      startDate:
        master.timeCheck === '1'
          ? formatDateTime(master.startDate, `${master.startTime}00`)
          : '',
      endDate:
        master.timeCheck === '1'
          ? formatDateTime(master.endDate, `${master.endTime}59`)
          : '',
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const {
      manifDeclMwbQryList = [],
      manifDeclMwbQryStat1: mawbQryStat1Temp = {} as ImanifDeclMwbQryStat1,
      manifDeclMwbQryStat2: mawbQryStat2Temp = {} as ImanifDeclMwbQryStat2,
    } = (result.data.data || {}) as IsearchResponse;
    console.log('mawbQryStat1Temp', mawbQryStat1Temp);
    console.log('mawbQryStat2Temp', mawbQryStat2Temp);
    console.log('result', result);
    console.log('mawbQryList', manifDeclMwbQryList);
    console.log('mawbQryList2', (manifDeclMwbQryList || [])?.length > 0);
    if ((manifDeclMwbQryList || [])?.length > 0) {
      setColList(
        getColWidthByField([
          { headerName: '項次', field: 'itemNo' },
          { headerName: '報單號碼', field: 'lastDeclNo' },
          { headerName: '類別', field: 'appType' },
          { headerName: '主號', field: 'mawbNo' },
          { headerName: '分號', field: 'hawbNo' },
          { headerName: '申報', field: 'piece' },
          { headerName: '進倉', field: 'gciPiece' },
          { headerName: '出倉', field: 'gcoPiece' },
          { headerName: '通關方式', field: 'goodsStat' },
          { headerName: '申報重量', field: 'weight' },
          { headerName: '進倉重量', field: 'gciWeight' },
          { headerName: '併袋號碼', field: 'expBagNo' },
          { headerName: '船舶航次', field: 'voyageNo' },
          { headerName: '海掛', field: 'vesselRegNo' },
          {
            headerName: '艙號',
            field: 'manifNo',
          },
          { headerName: '快遞倉站', field: 'warehouse' },
          { headerName: '報關箱號', field: 'boxNo' },
        ])
      );
      setRowData(manifDeclMwbQryList);
      setMawbQryStat1(mawbQryStat1Temp);
      setMawbQryStat2(mawbQryStat2Temp);
      setOpenSearchTable(true);
    } else {
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.startDate.length === 0) {
      master.startDate = getDateDayPlus();
    }
    if (master.endDate.length === 0) {
      master.endDate = getDateDayPlus();
    }

    let canQry: boolean;
    canQry = false;
    for (let i = 1; i <= 5; i += 1) {
      if ((master[`mawbNo${i}`] as string).length > 0) {
        canQry = true;
      }
    }
    if (!canQry) {
      enqueueSnackbar(`至少要輸入一筆主號`);
      return;
    }

    if (
      (master.timeCheck === '1' &&
        (!master.endDateValid ||
          !master.endTimeValid ||
          !master.startDateValid ||
          !master.startTimeValid)) ||
      !(
        master.startDate &&
        master.endTime &&
        master.startDate &&
        master.startTime
      )
    ) {
      return;
    }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      let expressResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      if (chkCode1.length > 0) {
        expressResult = await getExpressName(
          updateObj,
          master as unknown as Iobject
        );
        setExpressName(expressResult.text);
      } else {
        setExpressName('');
      }
      setFormError(warehouseResult.error || expressResult.error);
    }
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setExpressName(
      master.chkCode1.length > 1 ? warehouseRedux[0].expressName : ''
    );

    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };

  return (
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area">
        {/* <Breadcrumbs>
          <Link
            className="icon-item"
            color="inherit"
            href="/"
            onClick={breadClick}
          >
            <HomeIcon className="icon" />
            首頁
          </Link>
          <Link
            color="inherit"
            href="/getting-started/installation/"
            onClick={breadClick}
          >
            進出倉作業查詢
          </Link>
          <Typography color="textPrimary">主提單查詢</Typography>
        </Breadcrumbs> */}
      </div>
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 艙報單主號差異表
          </div>
        </div>
        <div className="input-area">
          {/* 20210325 新增權限判斷 */}
          {userType && !isType3(userType) && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                記帳代號：
              </VcEGrid>

              <VcGrid item xs={12} sm={2}>
                <Input
                  name="chkCode1"
                  disabled={userTypeList.type2.indexOf(userType) !== -1}
                  maxLength={4}
                  value={master.chkCode1}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
              <VcGrid item xs={12} sm={3}>
                {expressName && (
                  <Alert
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    severity="info"
                    icon={false}
                  >
                    {expressName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>
                {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                  userType
                ) !== -1
                  ? '*'
                  : ''}
                快遞倉站：
              </FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={2}>
              <WarehouseModal
                value={master.warehouse}
                updateData={updateData}
                setStatus={setWarehouseName}
              />
            </VcGrid>

            <VcGrid item xs={12} sm={3}>
              {warehouseName && (
                <Alert
                  severity="info"
                  style={{
                    width: '100%',
                    color: 'red',
                    margin: '0 0.5rem',
                    fontSize: '1em',
                  }}
                  icon={false}
                >
                  {warehouseName}
                </Alert>
              )}
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              進倉日期區間：
            </VcEGrid>
            <VcGrid item xs={12} sm style={{ maxWidth: 800 }}>
              <DateTimeSePickersTyping
                key={random}
                required={master.timeCheck === '1'}
                disabled={master.timeCheck === '0'}
                updateData={updateData}
                style={{ maxWidth: 800 }}
                names={[
                  ['startDate', 'startTime'],
                  ['endDate', 'endTime'],
                ]}
                data={master}
                setDayRange={3}
              />
            </VcGrid>
            <VcGrid item xs={12} sm={2}>
              <CheckBox
                label="加入時間查詢"
                checked={master.timeCheck === '1'}
                name="timeCheck"
                onChange={(e) => {
                  setMaster((prev) => ({
                    ...prev,
                    startDate: masterDefaultValue.startDate,
                    startTime: masterDefaultValue.startTime,
                    endDate: masterDefaultValue.endDate,
                    endTime: masterDefaultValue.endTime,
                    ...checkboxChange()(['1', '0'])(e),
                  }));
                }}
              />
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*主號：</FormTitle>
            </VcEGrid>

            <VcEGrid item xs={2} sm={2} style={{ paddingRight: '0.5em' }}>
              <Input
                maxLength={35}
                value={master.mawbNo1}
                name="mawbNo1"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
              ,
            </VcEGrid>
            <VcEGrid item xs={2} sm={2} style={{ paddingRight: '0.5em' }}>
              <Input
                maxLength={35}
                value={master.mawbNo2}
                name="mawbNo2"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
              ,
            </VcEGrid>
            <VcEGrid item xs={2} sm={2} style={{ paddingRight: '0.5em' }}>
              <Input
                maxLength={35}
                value={master.mawbNo3}
                name="mawbNo3"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
              ,
            </VcEGrid>
            <VcEGrid item xs={2} sm={2} style={{ paddingRight: '0.5em' }}>
              <Input
                maxLength={35}
                value={master.mawbNo4}
                name="mawbNo4"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
              ,
            </VcEGrid>
            <VcEGrid item xs={2} sm={2} style={{ paddingRight: '0.5em' }}>
              <Input
                maxLength={35}
                value={master.mawbNo5}
                name="mawbNo5"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </VcEGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              分號：
            </VcEGrid>
            <Grid item xs={12} sm={2}>
              <Input
                maxLength={35}
                value={master.hawbNo || ''}
                name="hawbNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('download')}
            >
              下載Excel
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
        </Grid>
      </form>
      {openSearchTable && (
        <>
          <DivStyle>
            <Grid container>
              <VcGrid item xs={4} sm={2}>
                主號： {mawbQryStat1.mwbCnt || 0} 筆
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                分號總筆數： {mawbQryStat1.hwbCnt || 0} 筆
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                總件數： {mawbQryStat1.pieceCnt || 0} 件
              </VcGrid>
              <VcGrid item xs={4} sm={2}>
                未申報分號筆數： {mawbQryStat1.unHwbCnt || 0} 筆
              </VcGrid>
              <VcGrid item xs={4} sm={2}>
                未申報件數： {mawbQryStat1.unPieceCnt || 0} 件
              </VcGrid>
            </Grid>

            <Grid container>
              <VcGrid item xs={4} sm={2}>
                已申報分號數： {mawbQryStat2.apHwbCnt || 0} 筆
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                已申報件數： {mawbQryStat2.apPieceCnt || 0} 件
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                進倉： {mawbQryStat2.gciPiece || 0} 件
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                出倉： {mawbQryStat2.gcoPiece || 0} 件
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                進倉重量： {mawbQryStat2.gciWeight || 0}
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                申報重量： {mawbQryStat2.weight || 0}
              </VcGrid>
            </Grid>
          </DivStyle>
          <Table
            key={randomValue}
            data={rowData as unknown as Iobject[]}
            columns={colList}
            rowsPerPageOptions={[100, 50, 10]}
            rootProps={{ style: { height: '400px' } }}
            pageSize={100}
          />
        </>
      )}
    </div>
  );
};

export default ManifDeclMwbQry;
